export const FETCH_REQUEST_GENERALS = "FETCH_REQUEST_GENERALS";
export const FETCH_REQUEST_GENERAL = "FETCH_REQUEST_GENERAL";
export const EDIT_REQUEST_GENERAL = "EDIT_REQUEST_GENERAL";
